import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, CheckCircleIcon, BotIcon, UserIcon } from 'lucide-react';
export function Solution() {
  return <section className="py-24 bg-surface/30 relative dot-pattern border-y border-border/50" data-id="element-122">
      <div className="max-w-5xl mx-auto px-6" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-125">
            Conoce CONECKTA
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-126">
            Un sistema que responde automáticamente a tus prospectos, los
            califica y agenda citas en tu calendario — para que tú te enfoques
            en cerrar, no en perseguir.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative max-w-3xl mx-auto" data-id="element-127">
          {/* Glow effect behind mockup */}
          <div className="absolute inset-0 bg-primary/20 blur-[100px] rounded-full -z-10" data-id="element-128" />

          <div className="bg-navy border border-border rounded-2xl shadow-2xl overflow-hidden" data-id="element-129">
            {/* Mockup Header */}
            <div className="bg-surface border-b border-border px-4 py-3 flex items-center gap-2" data-id="element-130">
              <div className="w-3 h-3 rounded-full bg-red-500/80" data-id="element-131" />
              <div className="w-3 h-3 rounded-full bg-yellow-500/80" data-id="element-132" />
              <div className="w-3 h-3 rounded-full bg-green-500/80" data-id="element-133" />
              <div className="mx-auto text-xs font-medium text-gray-500 flex items-center gap-2" data-id="element-134">
                <BotIcon className="w-4 h-4" data-id="element-135" /> CONECKTA AI
              </div>
            </div>

            {/* Mockup Body */}
            <div className="p-6 md:p-10 relative" data-id="element-136">
              {/* Chat Interaction */}
              <div className="space-y-6 mb-8" data-id="element-137">
                <div className="flex gap-4 items-end justify-end" data-id="element-138">
                  <div className="bg-surface border border-border text-gray-300 p-4 rounded-2xl rounded-br-none max-w-[80%] text-sm md:text-base" data-id="element-139">
                    Hola, vi su anuncio y me gustaría saber más sobre sus
                    servicios.
                  </div>
                  <div className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center shrink-0" data-id="element-140">
                    <UserIcon className="w-4 h-4 text-gray-300" data-id="element-141" />
                  </div>
                </div>

                <div className="flex gap-4 items-end" data-id="element-142">
                  <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center shrink-0" data-id="element-143">
                    <BotIcon className="w-4 h-4 text-white" data-id="element-144" />
                  </div>
                  <div className="bg-primary/10 border border-primary/20 text-white p-4 rounded-2xl rounded-bl-none max-w-[80%] text-sm md:text-base" data-id="element-145">
                    ¡Hola! Claro que sí. Para darte la mejor información, ¿para
                    qué fecha te gustaría agendar una breve llamada de
                    descubrimiento?
                  </div>
                </div>
              </div>

              {/* Calendar Widget */}
              <div className="bg-surface border border-border rounded-xl p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 ml-12" data-id="element-146">
                <div className="flex items-center gap-4" data-id="element-147">
                  <div className="bg-navy p-3 rounded-lg border border-border" data-id="element-148">
                    <CalendarIcon className="w-6 h-6 text-secondary" data-id="element-149" />
                  </div>
                  <div data-id="element-150">
                    <div className="font-bold text-white" data-id="element-151">
                      Llamada de Descubrimiento
                    </div>
                    <div className="text-sm text-gray-400" data-id="element-152">
                      Mañana, 10:00 AM - Zoom
                    </div>
                  </div>
                </div>
                <div className="bg-primary/20 text-primary px-4 py-2 rounded-lg text-sm font-bold border border-primary/30 w-full sm:w-auto text-center" data-id="element-153">
                  Cita Agendada
                </div>
              </div>

              {/* Status Indicator Badge */}
              <motion.div initial={{
              scale: 0.8,
              opacity: 0
            }} whileInView={{
              scale: 1,
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5,
              type: 'spring'
            }} className="absolute -bottom-5 right-6 md:-right-6 bg-surface border border-border px-5 py-3 rounded-full flex items-center gap-3 shadow-xl z-10" data-id="element-154">
                <CheckCircleIcon className="text-green-400 w-5 h-5" data-id="element-155" />
                <span className="font-bold text-sm text-white" data-id="element-156">
                  Prospecto Calificado
                </span>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}